import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  CircularProgress,
  TextField,
} from '@material-ui/core';
import { useSnackbar } from 'notistack';
import UploadRequest from '../../requests/api/upload';
import {
  BLOG_COVERS,
  BLOG_OG,
  SUCCESS_STORY_COVERS,
  SUCCESS_STORY_OG,
} from '../../utils/const/uploadFolders';

function ImageUploadField({
  label,
  name,
  folder,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  required,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handlePickFile = () => {
    inputRef.current?.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;

    setUploading(true);
    const response = await UploadRequest.postUploadImage({ file, folder });
    setUploading(false);

    if (response.success && response.data?.data?.url) {
      onChange(response.data.data.url);
      enqueueSnackbar('Imagen subida', { variant: 'success' });
    } else {
      enqueueSnackbar(response.data?.errorMessage || 'No se pudo subir la imagen', {
        variant: 'warning',
      });
    }
  };

  return (
    <Box>
      <Box display="flex" alignItems="flex-start" style={{ gap: 8 }}>
        <TextField
          error={error}
          fullWidth
          helperText={helperText}
          label={label}
          name={name}
          onBlur={onBlur}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          value={value}
          variant="outlined"
        />
        <Button
          variant="outlined"
          onClick={handlePickFile}
          disabled={uploading}
          style={{ marginTop: 4, whiteSpace: 'nowrap' }}
        >
          {uploading ? <CircularProgress size={20} /> : 'Subir'}
        </Button>
        <input
          ref={inputRef}
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
      </Box>
      {value ? (
        <Box mt={1}>
          <img
            src={value}
            alt="Vista previa"
            style={{ maxHeight: 120, maxWidth: '100%', borderRadius: 4 }}
          />
        </Box>
      ) : null}
    </Box>
  );
}

ImageUploadField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  folder: PropTypes.oneOf([
    BLOG_COVERS,
    BLOG_OG,
    SUCCESS_STORY_COVERS,
    SUCCESS_STORY_OG,
  ]).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  required: PropTypes.bool,
};

ImageUploadField.defaultProps = {
  value: '',
  onBlur: undefined,
  error: false,
  helperText: undefined,
  required: false,
};

export default ImageUploadField;
